import Dialog from 'Features/Dialog/Dialog'
import { IForumSearchResultItem } from 'Frontend/scripts/models/forums.model'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { deleteForumThread, reviewForumThread } from 'Frontend/scripts/services/forums.service'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { FunctionComponent, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface IArchivedOrPendingArchivedThreadProps {
  thread: IForumSearchResultItem
  isArchived: boolean
  callback: () => void
}

const ArchivedOrPendingArchivedThread: FunctionComponent<IArchivedOrPendingArchivedThreadProps> = ({
  thread,
  isArchived,
  callback,
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false)
  const [isSomethingWentWrongDialogOpen, setIsSomethingWentWrongDialogOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const deleteThread = () => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      deleteForumThread(token.csrfToken, thread.id).then((status) => {
        if (status == 200) {
          callback()
        } else {
          setIsSomethingWentWrongDialogOpen(true)
        }
        setIsDeleteDialogOpen(false)
      })
    })
  }

  const reviewThread = () => {
    reviewForumThread(thread.id).then((statusOK) => {
      if (statusOK) {
        callback()
      } else {
        setIsSomethingWentWrongDialogOpen(true)
      }
    })
  }

  return (
    <div className="manage-forums__thread-item d-flex flex-column gap-3">
      <div className="d-flex justify-content-between position-relative">
        <div>
          <a className="manage-forums__thread-item-link" href={thread?.url}>
            {thread?.title}
          </a>
        </div>
      </div>
      <div className="d-flex flex-wrap gap-2">
        {thread.tags.map((tag) => (
          <div className="bg-light rounded-pill forum-thread__tags--small text-capitalize" key={`tag-${tag.tagId}`}>
            {tag.name}
          </div>
        ))}
      </div>
      <div className="d-flex gap-2 flex-shrink-0 justify-content-md-end justify-content-start">
        <Button
          variant="secondary"
          className="align-self-center flex-shrink-0"
          size="sm"
          onClick={() => {
            reviewThread()
          }}
        >
          {isArchived ? t('dashboard.threads.republish') : t('dashboard.threads.approve-review')}
        </Button>
        <Button
          variant="dark"
          className="align-self-center flex-shrink-0"
          size="sm"
          onClick={() => {
            setIsDeleteDialogOpen(true)
          }}
        >
          {t('dashboard.threads.delete')}
        </Button>
        <Dialog
          isOpen={isDeleteDialogOpen}
          verificationText={t('verification-delete-thread')}
          submitText={t('yes-delete-thread')}
          abortText={t('abort')}
          buttonVariant="dark"
          callbackSubmit={() => deleteThread()}
          callbackClose={() => setIsDeleteDialogOpen(false)}
        />
        <Dialog
          isOpen={isSomethingWentWrongDialogOpen}
          verificationText={t('dashboard.threads.something-went-wrong')}
          submitText={t('dashboard.threads.ok')}
          buttonVariant="secondary"
          callbackSubmit={() => setIsSomethingWentWrongDialogOpen(false)}
        />
      </div>
    </div>
  )
}

export default ArchivedOrPendingArchivedThread
